import { getAnalyticsConsent } from 'portal-sdk';
import * as React from 'react';

export const useAnalyticsConsent = () => {
  const [consent, setConsent] = React.useState(() => getAnalyticsConsent());

  const onConsentReady = React.useCallback(() => {
    setConsent(getAnalyticsConsent());
  }, []);

  React.useEffect(() => {
    window.addEventListener('CookiebotOnConsentReady', onConsentReady);

    return () => {
      window.removeEventListener('CookiebotOnConsentReady', onConsentReady);
    };
  }, [onConsentReady]);

  return consent;
};
